import { createContext, useContext } from 'react';
import { action, observable } from 'mobx';
import { AcknowledgeAlertMutation_acknowledgeAlert_alert, AlertsQuery_alert } from 'api';

type Required<T> = {
  value: T;
  error: string;
};

const emptyValue = { error: ' ', value: '' };

class AlertAcknowledgeForm {
  @observable id = '';
  @observable isSubmitting = false;
  @observable editMode = false;

  @observable notes: Required<string> = {
    value: '',
    error: ' '
  };

  @action init = (alert: AcknowledgeAlertMutation_acknowledgeAlert_alert | AlertsQuery_alert) => {
    this.editMode = true;
    this.notes.value = alert.notes ? alert.notes : '';
    this.id = alert.id ? alert.id.toString() : '';
  };

  @action reset = () => {
    this.id = '';
    this.isSubmitting = false;
    this.editMode = false;
    this.notes = emptyValue;
  };

  @action handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case 'notes':
        this[event.target.name as 'notes'] = {
          error: ' ',
          value: event.target.value
        };
        break;

      default:
        throw new Error('This field is not supported');
    }
  };

  @action getValuesBeforeAck = () => {
    this.isSubmitting = true;
    return {
      alertInput: {
        id: this.id,
        notes: this.notes.value
      }
    };
  };

  @action validateFields = () => {
    let errors = 0;
    if (!this.notes.value) {
      this.notes.error = 'Notes are required';
      errors += 1;
    }
    return errors;
  };
}

export const AlertAcknowledgeFormContext = createContext(new AlertAcknowledgeForm());

export const useAlertAcknowledgeFormContextStore = () => useContext(AlertAcknowledgeFormContext);

export default AlertAcknowledgeForm;
